/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AnalyticDto } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class MyChannelAnalytic<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description 채널 분석 정보
   *
   * @tags my channel analytic
   * @name GetStatistics
   * @summary 채널 분석 정보
   * @request GET:/v2/me/channels/{channelId}/analytics
   * @secure
   */
  getStatistics = (
    channelId: number,
    query: {
      /**
       * top referer limit default: 3
       * @format int32
       */
      limitSize?: number;
      /**
       * 'yyyy-MM-dd' (시작 날짜)
       * @format date
       */
      from: string;
      /**
       * 'yyyy-MM-dd' (마지막 날짜)
       * @format date
       */
      to: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AnalyticDto, any>({
      path: `/v2/me/channels/${channelId}/analytics`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
}
